import React from 'react';
import {Col, Row}from 'react-bootstrap';

const DetailField = ({label, children}) => {
    return (
        <Row>
            <Col sm={6} lg={3}>{label}:</Col>
            <Col sm={6} lg={3}>{children}</Col>
        </Row>
    )
};

export default DetailField;


// WEBPACK FOOTER //
// ./src/components/admin/ppc/user/detail-field.jsx